import React, { useState, useCallback, useEffect } from 'react'
import { Flex } from 'reflexbox'
import { toast } from 'react-toastify'
import { Formik, Form } from 'formik'
import { useHistory } from 'react-router-dom'

import Breadcrumb from 'components/Breadcrumb'
import Loader from 'components/Loader'
import Card from 'components/Card'
import Button from 'components/Button'
import { SemiTitle, Title } from 'components/Typography'
import { SelectField, CheckboxField, NumberField } from 'components/Form'

import { getPartners } from 'services/partners'
import { getPackages } from 'services/packages'
import { createOrderNoPayment } from 'services/orders'

import { ErrorMessage } from './styles'

const OrdersNew = () => {
  const [isLoading, setLoading] = useState()
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
    totalPages: 1,
    totalRecords: 0,
  })
  const [packages, setPackages] = useState([])
  const [errors, setErrors] = useState(null)

  const history = useHistory()

  const breadcrumbPath = [
    {
      label: 'Lista de parceiros pré pago',
      link: '/staff/partners/list',
    },
    {
      label: 'Créditos em pacotes para Parceiros',
    },
  ]

  const loadOptions = useCallback(
    async search => {
      try {
        if (search) {
          setPagination({ page: 1, limit: 10 })
        }

        const res = await getPartners({ search, pagination })
        const formattedData = res.partners.map(partner => ({ label: partner.company_name, value: partner.id }))

        if (res.pagination.currentPage !== res.pagination.totalPages)
          setPagination({
            ...pagination,
            currentPage: res.pagination.currentPage + 1,
            pageSize: res.pagination.pageSize,
          })

        return {
          options: formattedData,
          hasMore: res.pagination.currentPage !== res.pagination.totalPages,
        }
      } catch (e) {
        console.log(e)
        if (!toast.isActive(toastfyLoadOptionsErrorID)) {
          toastfyLoadOptionsErrorID = toast.error('Não foi possível carregar a lista de parceiros.')
        }
        return {
          options: [],
          hasMore: false,
        }
      }
    },
    [pagination],
  )

  const handleSubmit = async values => {
    const errors = []

    const partner_ids = values.partners.map(({ value }) => value)

    if (!partner_ids.length && !values.select_all) {
      errors.push('Você deve selecionar ao menos um parceiro ou marcar a opção "Selecionar todos os parceiros"')
    }

    const order_items = values.packages.reduce((items, quantity, package_id) => {
      if (!quantity || quantity === '0') return items

      return [
        ...items,
        {
          package_id,
          quantity: +quantity,
        },
      ]
    }, [])

    if (!order_items.length) {
      errors.push('Você deve preencher a quantidade de ao menos um pacote.')
    }

    setErrors(errors)

    if (!errors.length) {
      setErrors(null)

      try {
        await createOrderNoPayment({ partner_ids, order_items, all: values.select_all })

        toast.success('Pacotes creditados no saldo dos parceiros com sucesso!')

        history.goBack()
      } catch (err) {
        console.log(err)
        toast.error('Não foi possível realizar a operação.')
      }
    }
  }

  useEffect(() => {
    const fetchPackages = async () => {
      setLoading(true)
      try {
        const { data } = await getPackages()
        setPackages(data)
      } catch (e) {
        console.log(e)
        toast.error('Não foi possivel carregar os pacotes disponiveis no momento.')
      } finally {
        setLoading(false)
      }
    }

    fetchPackages()
  }, [])

  return (
    <Flex flexDirection='column'>
      {isLoading ? (
        <Flex justifyContent='center' alignItems='center' height='200px'>
          <Loader />
        </Flex>
      ) : (
        <>
          <Breadcrumb children={breadcrumbPath} />
          <Title as='h3'>Créditos em pacotes para Parceiros</Title>
          <Card mt={24}>
            <Formik initialValues={{ select_all: false, partners: [], packages: [] }} onSubmit={handleSubmit}>
              {({ isSubmitting, values }) => (
                <Form>
                  <Flex flexDirection='column' width={[1]}>
                    <CheckboxField mb='32px' name='select_all' label='Selecionar todos os parceiros' />
                    <SelectField
                      mb='24px'
                      maxWidth={384}
                      label='Parceiros'
                      placeholder='Selecione os parceiros'
                      name='partners'
                      multiple
                      disabled={values.select_all}
                      loadOptions={loadOptions}
                    />

                    <SemiTitle>Selecione a quantidade para cada pacote</SemiTitle>

                    <Flex mt='8px' flexDirection='column' mt='24px' width={[1, 384]}>
                      {packages &&
                        packages.map(({ id, name }) => (
                          <NumberField
                            mb='24px'
                            label={name}
                            name={`packages[${id}]`}
                            placeholder='2'
                            decimalScale='0'
                          />
                        ))}
                    </Flex>
                  </Flex>

                  {errors && (
                    <ErrorMessage>
                      <ul>
                        {errors.map(error => (
                          <li>{error}</li>
                        ))}
                      </ul>
                    </ErrorMessage>
                  )}
                  <Flex width={[1, '384px']} justifyContent='space-between'>
                    <Button onClick={history.goBack} type='button' outlined>
                      Voltar
                    </Button>
                    <Button type='submit' disabled={isSubmitting}>
                      {isSubmitting ? <Loader /> : 'Salvar'}
                    </Button>
                  </Flex>
                </Form>
              )}
            </Formik>
          </Card>
        </>
      )}
    </Flex>
  )
}
export default OrdersNew
